

/**
 * A helper method for debouncing a function call so it's not called too often.
 * a good explanation of the concept can be found here:
 * https://css-tricks.com/debouncing-throttling-explained-examples/
 */
export default function(func, wait) {
  var timeout;

  return function() {
    var context = this;
    var args = arguments;

    if (timeout) {
      window.clearTimeout(timeout);
    }

    timeout = window.setTimeout(function() {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}

